export enum AssemblyDisassemblyOperationTypeEnum {
    Assembly = 0,
    Disassembly = 1
}